import React, { useState } from 'react';
import FloatingHamburgerButton from '../shared/FloatingHamburgerButton';

const MobileQuestionNav = ({
  questions,
  currentQuestionIndex,
  onQuestionSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getQuestionAccuracy = (question) => {
    if (question.accuracy !== undefined && question.accuracy !== null) {
      return Math.round(question.accuracy * 100);
    }
    if (question.matchedSoalStat && typeof question.matchedSoalStat.accuracy === 'number') {
      return question.matchedSoalStat.accuracy;
    }
    return question.isCorrect ? 100 : 0;
  };

  const getSessionAccuracy = (question) => {
    if (question.matchedSoalStat) {
      if (question.matchedSoalStat['session-accuracy'] !== undefined && question.matchedSoalStat['session-accuracy'] !== null) {
        return question.matchedSoalStat['session-accuracy'];
      }
      if (question.matchedSoalStat.accuracy !== undefined && question.matchedSoalStat.accuracy !== null) {
        return question.matchedSoalStat.accuracy;
      }
    }
    return null;
  };

  const handleQuestionClick = (index) => {
    onQuestionSelect(index);
    setIsOpen(false);
  };

  return (
    <>
      {/* Floating Button - visible below xl (phone + tablet; desktop uses sidebar) */}
      <FloatingHamburgerButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />

      {/* Overlay - only when open */}
      {isOpen && (
        <div
          role="presentation"
          className="fixed inset-0 bg-black/50 z-[1001] opacity-100 transition-opacity duration-300 xl:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Navigation Panel */}
      <div
        className={`fixed bottom-[198px] max-md:bottom-[185px] right-6 flex flex-col gap-2 items-center z-[1002] transition-all duration-300 xl:hidden ${
          isOpen ? 'opacity-100 translate-y-0 scale-100 pointer-events-auto' : 'opacity-0 translate-y-5 scale-95 pointer-events-none'
        }`}
      >
        {questions.map((question, index) => {
          const sessionAccuracy = getSessionAccuracy(question);
          const accuracy = getQuestionAccuracy(question);
          const isCorrectMobile =
            sessionAccuracy !== null && sessionAccuracy !== undefined
              ? sessionAccuracy >= 80
              : accuracy >= 80;
          const isActive = index === currentQuestionIndex;

          const itemBase =
            'w-10 h-10 rounded-full border-2 bg-[var(--card-bg)] flex items-center justify-center cursor-pointer transition-all duration-200 p-0 m-0 text-base font-semibold text-[var(--text-primary)]';
          const itemCorrect = isCorrectMobile ? 'border-emerald-500' : 'border-red-500';
          const itemActive = isActive ? 'border-[3px] scale-105 shadow-[var(--shadow-sm)]' : '';

          return (
            <div key={index} className="flex flex-col items-center">
              <button
                type="button"
                className={`${itemBase} ${itemCorrect} ${itemActive}`}
                onClick={() => handleQuestionClick(index)}
              >
                {index + 1}
              </button>
              <div className="py-0.5 px-1.5 bg-[var(--card-bg)] border border-[var(--border-color)] rounded-lg text-[10px] font-semibold text-[var(--text-primary)] whitespace-nowrap min-w-6 text-center leading-tight -mt-0.5">
                {sessionAccuracy !== null && sessionAccuracy !== undefined ? sessionAccuracy : '--'}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default MobileQuestionNav;
